import React from 'react';
import clsx from 'clsx';

import { useRouteMatch } from 'react-router';
import Link from '../link/Link';

type Props = {
  activeClassName?: string;
} & React.ComponentProps<typeof Link>;

const NavLink = ({
  activeClassName,
  className,
  to,
  ...props
}: Props) => {
  const active = useRouteMatch(to ?? '') && to;

  return (
    <Link
      tabIndex={-1}
      {...props}
      to={to}
      className={clsx(className, {
        [String(activeClassName)]: Boolean(activeClassName && active),
      })}
    />
  );
};

export default NavLink;
